import { Col, DatePicker, Row } from "@pankod/refine-antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { IMask } from "react-imask";
import { DefaultMaskedInput } from "./default-masked-input";

interface DateTimeInputProps {
  value?: Dayjs | string;
  onChange?: (value?: Dayjs) => void;
  disabled?: boolean;
}

export const DateTimeInput: React.FC<DateTimeInputProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const [dateTime, setDateTime] = useState({
    date: value ? dayjs(value) : null,
    time: value ? dayjs(value).format("HH:mm") : "",
  });

  useEffect(() => {
    const currentValue = value ? dayjs(value) : null;

    setDateTime({
      date: currentValue ? currentValue : null,
      time: currentValue ? currentValue.format("HH:mm") : "",
    });
  }, [value]);

  const handleDateChange = (date: Dayjs | null) => {
    if (!date) {
      setDateTime({
        date: null,
        time: "",
      });

      onChange?.();
      return;
    }

    const [hour, minute] = dateTime.time
      ? dateTime.time.split(":").map(Number)
      : [0, 0];

    const updatedDate = date.hour(hour).minute(minute).second(0);

    setDateTime({
      date: updatedDate,
      time: dateTime.time || "",
    });

    onChange?.(updatedDate);
  };

  const handleTimeChange = (time: string) => {
    setDateTime((prev) => ({
      ...prev,
      time,
    }));

    if (time.length === 5 && dateTime.date) {
      const [hour, minute] = time.split(":").map(Number);

      if (
        !isNaN(hour) &&
        !isNaN(minute) &&
        hour >= 0 &&
        hour <= 23 &&
        minute >= 0 &&
        minute <= 59
      ) {
        const updatedDate = dateTime.date.hour(hour).minute(minute).second(0);

        setDateTime({
          date: updatedDate,
          time,
        });

        onChange?.(updatedDate);
      }
    }
  };

  return (
    <Row gutter={8} align="middle" style={{ width: "100%" }}>
      <Col span={12}>
        <DatePicker
          value={dateTime.date}
          format="DD/MM/YYYY"
          onChange={handleDateChange}
          style={{ width: "100%" }}
          disabled={disabled}
        />
      </Col>

      <Col span={12}>
        <DefaultMaskedInput
          mask="HH:mm"
          className="ant-input"
          blocks={{
            HH: {
              mask: IMask.MaskedRange,
              from: 0,
              to: 23,
              maxLength: 2,
            },
            mm: {
              mask: IMask.MaskedRange,
              from: 0,
              to: 59,
              maxLength: 2,
            },
          }}
          overwrite
          autofix
          lazy={false}
          unmask={false}
          value={dateTime.time}
          onAccept={(value) => handleTimeChange(value)}
          style={{ width: "100%" }}
          disabled={!dateTime.date || disabled}
        />
      </Col>
    </Row>
  );
};
